import type { FaireBrandEntity } from "../../entity_types/brand";

export const brooklynSoapWorks: FaireBrandEntity = {
  token: "brooklyn-soap-works",
  type: "brand",
  name: "Brooklyn Soap Works",
  description: "Handcrafted natural soaps and skincare",
  rating: 4.9,
  location: "Brooklyn, NY",
  minimumOrderDollars: 150,
  tags: ["natural", "handmade", "skincare"],
  isInsider: true,
  categoryTokens: ["catalog_cat_bath-body"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "entity-db-bootstrap",
  },
};
